export const getListHeader = (hasProfiles: boolean, hasNoMatches: boolean): string | null => {
  if (hasProfiles) return "Select the profile to assign to this case:";
  if (hasNoMatches) return "No matching profiles found";
  return null;
};

/**
 * The match comes from a backend search (ranked/fuzzy, not a literal substring filter), so
 * only the first occurrence is surfaced — a best-effort visual cue, not an exhaustive marker
 * of every occurrence.
 */
export const findFirstMatch = (
  text: string,
  query: string,
): {
  before: string;
  match: string;
  after: string;
} | null => {
  const normalizedQuery = query.trim();
  const matchIndex = normalizedQuery
    ? text.toLowerCase().indexOf(normalizedQuery.toLowerCase())
    : -1;
  if (matchIndex === -1) return null;

  return {
    before: text.slice(0, matchIndex),
    match: text.slice(matchIndex, matchIndex + normalizedQuery.length),
    after: text.slice(matchIndex + normalizedQuery.length),
  };
};
